import Theme from '../theme';

/**
 * Create the action
 */

const { thunk, request, success, error } = Theme.index((fetch) => {
    return fetch.get('/themes');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
